/* eslint-disable prettier/prettier */
export const handleAnimationName = (t: number): number => {
    switch (t) {
        case 1400:
            return 4
        case 1800:
            return 4
        case 3200:
            return 22
        case 3600:
            return 22
        default:
            return 4
    }
}